import { render } from "./GoogleClassroomIntegrationSettings.vue?vue&type=template&id=ae5cb37e&ts=true"
import script from "./GoogleClassroomIntegrationSettings.vue?vue&type=script&lang=ts"
export * from "./GoogleClassroomIntegrationSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__